export const ORDER_LIST_GET = '[ORDER LIST] GET';
export const ORDER_LIST_SUCCESS = '[ORDER LIST] SUCCESS';
export const ORDER_LIST_FAIL = '[ORDER LIST] FAIL';
